import axios from "axios";

const WALLET_API = axios.create({
  baseURL: process.env.REACT_APP_WALLET_URL,
  withCredentials: true,
});

export { WALLET_API };
